import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface ArchAlignmentState {
	OnUpperJaw: boolean;
	OnLowerJaw: boolean;
}

export const createInitialState = (): ArchAlignmentState => ({
	OnUpperJaw: false,
	OnLowerJaw: false
});

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'arch-alignment', resettable: true })
export class ArchAlignmentStore extends Store<ArchAlignmentState> {
	constructor() {
		super(createInitialState());
	}
}
